import { Link } from "react-router-dom";
import Logo from "@/components/store/Logo";

export default function NotFound() {
  return (
    <div className="container-x py-24 text-center" data-testid="not-found-page">
      <div className="flex justify-center"><Logo on="light" /></div>
      <h1 className="font-heading text-5xl font-semibold mt-8">404</h1>
      <p className="text-ink-2 mt-3">This page has wandered off the counter.</p>
      <div className="flex justify-center gap-3 mt-8">
        <Link to="/" className="px-6 py-2.5 rounded-full bg-brand text-ivory text-sm btn-press" data-testid="nf-home">Back to home</Link>
        <Link to="/shop" className="px-6 py-2.5 rounded-full border border-brand/30 text-brand text-sm btn-press" data-testid="nf-shop">Browse jewellery</Link>
      </div>
    </div>
  );
}
